import { SimulationState } from 'features/simulations/utils';
import { useMemo } from 'react';

import './_SimulationStateBadge.scss';

interface Props {
    state: SimulationState;
}

const getModifier = (state: SimulationState): string => {
    switch (state) {
        case SimulationState.PREPARE_FOR_DRIVING:
        case SimulationState.DRIVING:
        case SimulationState.PREPARE_FOR_COMPLETION:
            return 'progressing';
        case SimulationState.RELEASING_MRC:
            return 'warning';
        case SimulationState.EXECUTING_MRM:
        case SimulationState.IN_MRC:
            return 'danger';
        case SimulationState.ARRIVED:
        case SimulationState.END:
            return 'complete';
        default:
            return 'neutral';
    }
};

const SimulationStateBadge = ({ state }: Props) => {
    const modifier = useMemo(() => getModifier(state), [state]);

    return <div className={`SimulationStateBadge SimulationStateBadge--${modifier}`}>{state}</div>;
};

export default SimulationStateBadge;
